import 'core-js';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { PersistGate } from 'redux-persist/integration/react'
import { Provider } from 'react-redux';
import { persistor, store } from './store';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
	<React.StrictMode>
		<Provider store={ store }>
            <PersistGate persistor={ persistor }>
                <App />
            </PersistGate>
        </Provider>
	</React.StrictMode>
);
